import config from './config'
import OrganisationReferenceInput from './input'

const OrganisationsFilter = (props) => <OrganisationReferenceInput {...props} validate={null} />

OrganisationsFilter.defaultProps = { source: config.options.referenceKey }

export default OrganisationsFilter
